module.exports = __webpack_public_path__ + "media/images/seeds/pieter-9806adbc754541f9fed58eee06802ef3.png";